import { useEffect, useRef, useState } from 'react';

export default function ContactHero() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 120);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative pt-40 pb-24 md:pt-52 md:pb-32 bg-[#f2ede5] overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://readdy.ai/api/search-image?query=a%20person%20writing%20a%20letter%20on%20wooden%20desk%20with%20tea%20and%20dried%20flowers%2C%20warm%20natural%20light%2C%20minimal%20japanese%20aesthetic%2C%20muted%20cream%20warm%20tones%2C%20peaceful%20cozy%20atmosphere&width=1920&height=700&seq=contact_hero&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div
        ref={ref}
        className={`relative z-10 w-full px-6 md:px-12 lg:px-20 transition-all duration-700 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <div className="flex items-center gap-3 mb-6">
          <div className="w-6 h-px bg-[#b08060]"></div>
          <span className="text-[0.8125rem] tracking-[0.2em] text-[#9a8470] font-medium uppercase">Contact</span>
        </div>
        <h1
          className="font-serif-tc text-[#2c2420] leading-[1.3] mb-6"
          style={{ fontSize: 'clamp(2rem, 5vw, 2.75rem)' }}
        >
          聯絡 / 諮詢
        </h1>
        <p className="text-[1.1875rem] leading-[1.75] text-[#5a4e42] max-w-xl">
          這是一個安全的開始。不需要準備什麼，也不需要立刻做決定。先聊聊你的狀態，再看看這裡是否適合你。
        </p>

        {/* Quick Action */}
        <div className="flex flex-wrap gap-4 mt-10">
          <a
            href="https://line.me"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#06C755] hover:bg-[#05a848] text-white text-[0.9375rem] font-medium transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-line-fill text-lg"></i>
            加入 LINE@ 諮詢
          </a>
          <a
            href="#trial-booking"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-[#c8b49a] bg-white hover:bg-[#f5f0e8] text-[#5a4e42] text-[0.9375rem] font-medium transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-calendar-check-line text-lg"></i>
            預約半價體驗課
          </a>
        </div>
      </div>
    </section>
  );
}
